import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useDialog } from '../../../hooks/use-dialog';
import { ProjectContext } from '../../../state/project-state/project-state';
import { Button } from '../../button/button';
import { InfoBox } from '../../info-box/info-box';
import { ArchiveProjectDialog } from '../dialogs/archive-project-dialog';
import { RestoreProjectDialog } from '../dialogs/restore-project-dialog';
import { Flex } from './styles';

const InactiveInfoBox = () => {
  const { t } = useTranslation();
  const { reloadProject } = React.useContext(ProjectContext);
  const archiveProjectDialog = useDialog();
  const restoreProjectDialog = useDialog();

  const activateButton = (
    <Button
      color="primary"
      variant="contained"
      onClick={() => {
        restoreProjectDialog.show();
      }}
    >
      {t('projectSettings.status.restoreButton', { ns: 'components' })}
    </Button>
  );

  const archiveButton = (
    <Button
      color="error"
      variant="contained"
      onClick={() => {
        archiveProjectDialog.show();
      }}
    >
      {t('projectSettings.status.archiveButton', { ns: 'components' })}
    </Button>
  );

  const renderInfoBox = () => {
    return (
      <>
        <InfoBox bottomMargin={true} color="yellow" leftIcon={{ icon: ['fad', 'lock-alt'] }}>
          <Flex>
            <div>{t('projectSettings.status.inactiveTitle', { ns: 'components' })}</div>
            <Flex gap={'0.5em'}>
              {archiveButton}
              {activateButton}
            </Flex>
          </Flex>
        </InfoBox>

        {archiveProjectDialog.render(
          <ArchiveProjectDialog
            onClose={(archived) => {
              archiveProjectDialog.hide();

              if (archived) {
                void reloadProject();
              }
            }}
          />,
        )}

        {restoreProjectDialog.render(
          <RestoreProjectDialog
            latestArchiveJob={undefined}
            onClose={(restored) => {
              restoreProjectDialog.hide();

              if (restored) {
                void reloadProject();
              }
            }}
          />,
        )}
      </>
    );
  };

  return <Component>{renderInfoBox()}</Component>;
};

const Component = styled.div``;

export { InactiveInfoBox };
